import script from "./BacktestStatsCards.vue?vue&type=script&setup=true&lang=js"
export * from "./BacktestStatsCards.vue?vue&type=script&setup=true&lang=js"

import "./BacktestStatsCards.vue?vue&type=style&index=0&id=32b1cccc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b1cccc"]])

export default __exports__